import axios from 'axios';
import React, { useEffect, useState} from 'react';
import { Bounce, Fade } from 'react-reveal';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Icon } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
import LinkCard from './Assets/linksCard'
import InputLinks from './Assets/linksData'
import { useNavigate} from 'react-router-dom';

function InputLandingPage() {
    /*#########################[Const]###########################*/
    let camData = JSON.parse(localStorage.getItem(`Magazin_Caisse_LocalD`));
    const navigate = useNavigate();

    /*#########################[UseEffect]###########################*/
    useEffect(() => {
        const inputIsLogged = localStorage.getItem(`Magazin_Caisse_LocalD`);
        if (!inputIsLogged) {window.location.href = "/C/logIn";}
    })

    /*#########################[Function]###########################*/
    const logOutInput = () =>{    
        localStorage.clear();
        window.location.href = "/C";
    }
    const NavigateFunction = (link) => {  navigate(link) }
    const handleFullscreen = () => {
        const element = document.documentElement; // Target the entire document
        
        if (!document.fullscreenElement) {
            // Enter fullscreen
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { // Safari
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE/Edge
                element.msRequestFullscreen();
            }
        } else {
            // Exit fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Safari
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        }
    };
    const Refresh = () =>{
        window.location.reload();
    }
    const ChangeThemeMode = () =>{
        if (InputLinks.themeMode == 'dark') {
            localStorage.setItem(`Magazin_Caisse_Theme`, 'ligth');
            window.location.reload()
        } else {
            localStorage.setItem(`Magazin_Caisse_Theme`, 'dark');
            window.location.reload()
        }
       
    }
    /*#########################[Card]###########################*/
    const MainTopCard = () =>{
        return(<>
            <div className={`card p-3 fixed-top border-0 shadow-sm rounded-0 ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1' : '' }`}>
                <div className='row'>
                    <div className='col-8 align-self-center'><h2> <span className="badge bg-info"> <span className='bi bi-window-sidebar '></span>  {camData.CA_Name} </span></h2></div>
                    <div className='col-4 align-self-center text-end' >
                        {/* <NavLink to='up' exact="true" className={({ isActive }) => isActive ? "ps-1 pe-1 abyedh-list-a-s me-4" : "ps-1 pe-1 abyedh-list me-4"}> <i className="bi bi-cloud-arrow-down-fill text-danger bi-upl "></i></NavLink> */}
                        <Button icon size='tiny' className='border-div bg-danger text-white me-3' onClick={() => NavigateFunction('up')}> <Icon name='cloud upload' />  MISE A JOUR  </Button>
                        <Button icon size='tiny' className='border-div' onClick={() => handleFullscreen()}> <Icon name='expand arrows alternate' /> </Button>
                        <Button icon size='tiny' className='border-div' onClick={() => Refresh()}> <Icon name='redo' /> </Button>
                        <Button icon size='tiny' className='border-div' onClick={() => ChangeThemeMode()}> <Icon name={InputLinks.themeMode == 'dark' ? 'sun text-warning' :'moon outline text-dark'} /> </Button>
                        <Button icon size='tiny' className='border-div' onClick={() => logOutInput()}> <Icon name='power off' /> </Button>
                    </div>
                </div>
            </div>
        </>)
    }

    return ( <>
    <div className={`spesific-commp ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-2' : '' }`} style={{height: '100vh', overflow: 'scroll'}}>

    
            <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
            <br />   
            <br />   
            <br />   
            <Fade >            
                <div className='container spesific-commp'>
                    <div className='row'>
                        <div className='col-6 mb-3'> <LinkCard data={InputLinks.main[0]} /> </div>
                        <div className='col-6 mb-3'> <LinkCard data={InputLinks.main[1]} /> </div>
                        <div className='col-6 mb-3'> <LinkCard data={InputLinks.main[2]} /> </div>
                        <div className='col-6 mb-3'> <LinkCard data={InputLinks.main[3]} /> </div>
                    </div>  
                    <br />  
                </div>
            </Fade> 
            </div>         
        </> );
}

export default InputLandingPage;